define(function(require) {
	const Marionette = require('backbone.marionette');
	const Radio = require('backbone.radio');
	const process_manager = require('civicsUtils/process_manager/process_manager');
	const LoginModel = require('civicsModels/login_model');
	const tpl = require('./templates/t_itv_login_signin.hbs');
	const ViewManager = require('civicsUtils/view_manager');
	const activation_model = require('civicsModels/core/activation_model');
	const factor_utility = require('civicsViews/core/two_factor_authentication/2fa_utility')
	const ccn = require('../../core_constants');
	const OAuthHelper = require('civicsUtils/oauth_helper');
    const AnonLoginModel = require('civicsModels/anonymous_login_model');
	const AccountExistModel = require('civicsModels/account_exist_model');
	const ModalRegion = require('civicsUtils/modal_region');
	const loginErrorUtility = require('civicsUtils/login_error_utility');

	return Marionette.ItemView.extend({
		template: tpl,
		tagName: 'div',
		className: 'signin-holder',
		initialize: function(options) {
			this.config = options.config;
			this.config.globalConfig = ViewManager.globalConfig();
			this.initializeOAuthProviders();
			this.modalRegion = options.modalRegion;
			this.twoFAUtil = new factor_utility({ modalRegion: this.modalRegion });
			

			this.model = new LoginModel();
			this.settings = this.config.loginChannel.request('original:settings');

			this.instance = "";

			if (this.options.config !== 'undefined' && this.options.config.instance !== undefined) {
				this.instance = this.config.instance.split("_WAR_").pop();
			}

			this.config.loginChannel.reply('signin:password', function() {
				return this.password;
			}, this);
			this.config.loginChannel.reply('signin:settings', function() {
				return this.settings;
			}, this);
			this.config.loginChannel.comply('signin:saveSettings', this.saveSettings.bind(this));
			if (this.settings.rememberMe) {
				this.model.set('username', this.settings.username);
			}
		},
		initializeOAuthProviders: function() {
			// Get all oauth providers from global config
			// Display login buttons only for those that are enabled and have a client id set
			this.redirectUri = window.location.origin + this.config.socialLoginRedirectPage;
			var socialLogin = this.config.globalConfig?.get('login')?.get('socialLogins');
			if(socialLogin !=null) {
				var providers = socialLogin.toJSON();
				this.oauthProviders = [];
				if(providers != null) {
					for(var i = 0; i < providers.length; i++) {
						var provider = providers[i];
						if(provider.enabled && provider.clientId !=null) {
							provider.iconElement = OAuthHelper.createIconElement(provider);
							provider.loginText =  i18n.t('CIVICS.LOGIN.LOGIN_WITH_PROVIDER', {provider: provider.providerName});
							this.oauthProviders.push(provider);
						}
					}
				}
			}				
		},
		modelEvents: {
			change: 'render'
		},
		events: {
			'click @ui.btnSubmit': 'signinClicked',
			'keyup @ui.inpCode': 'passwordKeyPress',
			'click @ui.socialLoginLink': 'handleSocialLogin'
		},
		ui: {
			ckbRememberMe: '.signinRememberMe',
			inpCode: '.password .input-text',
			inpName: '.username .input-text',
			btnSubmit: '.login-submit',
			forgotPasswordLink: '.link-forgot.password',
			forgotUsernameLink: '.link-forgot.username',
			registerLink: '.link-register',
			socialLoginLink: '.oauth-login-btn'
		},
		onRender: function () {
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

		},
		saveSettings:function(settings){
			this.settings.rememberMe = settings.rememberMe;
			this.settings.username = settings.username;
		},
		passwordKeyPress: function(e) {
			if (e.which === 13) { // enter keyCode
				e.preventDefault();
				e.stopPropagation();
			}
		},		
		onShow: function() {
			this.ui.ckbRememberMe.attr('checked', this.settings.rememberMe);
			
		},
		handleSocialLogin: function(e) {
			// Redirect to social login provider's login / grant permission page
			e.preventDefault();
			e.stopPropagation();

			const provider = $(e.currentTarget).data('provider-id');
			const oauthProvider = this.oauthProviders.find((p) => p.providerId === provider);
			
			// If there is an activation code in URL params, save it to session storage so we 
			// can retrieve it after logging in.
			if (this.config.urlParms && this.config.urlParms.activationCode) {
				App.sessionStorage.set('CIVICS', 'ACTIVATION_CODE', this.config.urlParms.activationCode);
			}
			OAuthHelper.buildAuthorizationUrl(oauthProvider, this.redirectUri)
			.then(function(authUrl) {
				window.location.href = authUrl;
			}).catch(function(error) {
				console.error(i18n.t('CIVICS.LOGIN.OAUTH_LOGIN_FAILED'), error);
				ViewManager.openAlert(i18n.t('CIVICS.LOGIN.OAUTH_LOGIN_FAILED'));
			});
			
		},	
		signinClicked: function(e) {
			// reset all error messages
			e.preventDefault();
			e.stopPropagation();
			ViewManager.resetErrorMessages(this);

			// Added entered password to the body tag to fix issue with two logins on the same page causing validation errors on reset password
			$('body.rhy-body').data("password", this.ui.inpCode.val());

			ViewManager.loading(true);
			if (this.config.urlParms && this.config.urlParms.activationCode) {
				var activationModel = new activation_model();
				activationModel.id = 1;
				activationModel.set({
					id:1,
					userName: this.ui.inpName.val(),
					activationCode: this.config.urlParms.activationCode
				});
				activationModel.save({id:1},{
					success: function(message, response, options) {
						this.signIn(e);
					}.bind(this),
					error: function(message, response, options) {
						if(response.status == 409){
							ViewManager.loading(false,false,false);
							this.triggerMethod('activationFailed');
						} else {
							ViewManager.errorToWindow(response);
						}
					}.bind(this)
				});
			} else {
				this.signIn(e);
			}
		},
		signIn: function(e) {
			const self = this;

			if (__DEV__) console.log('itvSignin-signinClicked e', e, 'this', this);
			this.password = this.ui.inpCode.val();
			const username = this.ui.inpName.val();

			// Empty check for fields
			let usernameEmpty = !$.trim(username);
			let passwordEmpty = !$.trim(this.password);

			if(usernameEmpty || passwordEmpty) {
				let returnObj = {};

				if(usernameEmpty) {
					returnObj.username = this.config.EmailUsernameOn ? i18n.t('CIVICS.LOGIN.MUST_ENTER_EMAIL') : i18n.t('CIVICS.LOGIN.MUST_ENTER_USERNAME');
				}

				if(passwordEmpty) {
					returnObj.password = i18n.t('CIVICS.LOGIN.MUST_ENTER_PASSWORD');
				}

				self.showErrorMessage(returnObj);
				ViewManager.loading(false);
			} else {
				const data = Backbone.Syphon.serialize(this);
				this.model = new LoginModel();
				this.model.set(data);
				this.model.save().done((model, response) => {
					ViewManager.loading(false);
					if (__DEV__) console.log('signinClicked success', model, response);
					if (response !== undefined) {
						const isMFAEnforced = this.config.globalConfig.get('mfaEnforced');
						if (isMFAEnforced) {
							$.when(this.twoFAUtil.loadAvailableFactors(true)).done((response) => {
								// If no available factors, show error on login form
								if (!response || !response.data || response.data.length === 0) {
									ViewManager.loading(false);
									this.showErrorMessage({ username: '', password: i18n.t('CIVICS.LOGIN.SIGN_IN_2FA_ERROR') });
									return;
								}
								// Store requiresMFAEnrollment flag in localStorage
								if (model && model.requiresMFAEnrollment !== undefined) {
									// Generate tab ID if not exists
									if (!App.sessionStorage.get('CIVICS', 'TAB_ID')) {
										App.sessionStorage.set('CIVICS', 'TAB_ID', Date.now() + '_' + Math.floor(Math.random() * 100));
									}
									App.localStorage.set('CIVICS', 'REQUIRES_MFA_ENROLLMENT', model.requiresMFAEnrollment);
									App.localStorage.set('CIVICS', 'MFA_SETUP_TAB_ID', App.sessionStorage.get('CIVICS', 'TAB_ID'));
								}
								this.triggerMethod('enforcedMFA', this.config);
							}).fail((response) => {
								ViewManager.loading(false);
								let respMessage = response?.responseJSON?.responseStatus?.message || null;
								let msg = loginErrorUtility.getLoginErrorMessage(response, respMessage, this.config);
								this.showErrorMessage({ username: '', password: msg });
							});
							return false;
						}
						self.settings.rememberMe = self.ui.ckbRememberMe.prop('checked');
						self.settings.username = data.username;
						self.config.loginChannel.command('signin:saveSettings', self.settings);
						self.config.loginChannel.command('go:checkStatus', self);
					} else {
						self.showErrorMessage({ username: '', password: self.config.SigninError });
					}
				}).fail((response, status, xhrResponse)=> {
					let respMessage = response && 
						response.responseJSON && 
						response.responseJSON.responseStatus ? response.responseJSON.responseStatus.message : null;
					if (response.statusCode().status == 401 && 
						response.responseJSON.data && 
						response.responseJSON.data.mfaStatus && 
						response.responseJSON.data.mfaStatus.toLowerCase() == ccn.NOTIFIED) 
					{//login succeeded, has 2FA enabled
						ViewManager.loading(false);
						this.handleFactorAuthentication(response, data);
					} else {
						ViewManager.loading(false);;
						var msg = loginErrorUtility.getLoginErrorMessage(response, respMessage, self.config);
						
						if (respMessage?.search('password has expired') !== -1) {
							App.sessionStorage.set('CIVICS', 'EXPIRED_PASSWORD', true);
							App.sessionStorage.set('CIVICS', 'EXPIRED_PASSWORD_USER', username);

							if (process_manager.hasActiveProcess()) {
								process_manager.markAsInterrupted(process_manager.INTERRUPTION_TYPES.EXPIREDPASSWORD);
							}

							const forgotPasswordPage = self.config.forgotPasswordPage || self.config.ForgotPasswordPage;
							if (forgotPasswordPage) {
								window.location.assign(forgotPasswordPage);
							}
						}
						self.showErrorMessage({ username: '', password: msg });
					}
				});
			}
		},
		handleFactorAuthentication:function(response, data){
			let modalRegion = this.options && this.options.modalRegion ? this.options.modalRegion : null;
			let faUtil = new factor_utility({
				modalRegion:modalRegion
			});
			let loginModel = new LoginModel(data);
			faUtil.authenticate(response, loginModel).done(()=>{
				this.settings.rememberMe = this.ui.ckbRememberMe.prop('checked');
				this.settings.username = data.username;
				this.config.loginChannel.command('signin:saveSettings', this.settings);
				this.config.loginChannel.command('go:checkStatus', this);
			}).fail(()=>{
			});
		},
		hideErrorMessages: function() {
			//We need to remove the pesky <br> that was added in the 'about to disable' message,
			//this does not get removed in resetErrorMessages.  We copy the children after we empty and I don;t remember why so I don;t want to change.
			this.ui.inpCode.parent().find('.helper-msg-container > .helper-msg').empty();
			this.ui.inpName.parent().removeClass('error');
			ViewManager.resetErrorMessages(this);
		},
		showErrorMessage: function(msg) {

			var error = {};
			error.validationError = msg;
			ViewManager.errorToWindow(error, this);
		},
		forgotPasswordPage: function() {
			if (this.config.forgotPasswordPage) {
				return this.config.forgotPasswordPage;
			}
			else {
				return this.config.ForgotPasswordPage;
			}
		},
		forgotUsernamePage: function() {
			if (this.config.forgotUsernameLink) {
				return this.config.forgotUsernameLink;
			}
			else {
				return this.config.ForgotUsernameLink;
			}
		},
		registerUserPage: function() {
			if (this.config.registerUserPage) {
				return this.config.registerUserPage;
			}
			else {
				return this.config.RegisterUserPage;
			}
		},
		templateHelpers: function() {
			return {
				TitleOn: this.config.TitleOn,
				Title: this.config.Title,
				EmailUsernameOn: this.config.EmailUsernameOn,
				EmailUsernameLabel: ((this.config.EmailUsernameOn) ? this.config.EmailUsernameLabel : i18n.t('CIVICS.LOGIN.USERNAME')),
				EmailUsernameAutocomplete: (this.config.EmailUsernameOn) ? "email" : "username",
				RememberMeOn: this.config.RememberMeOn,
				RememberMeLabel: this.config.RememberMeLabel,
				ForgotPasswordOn: this.config.ForgotPasswordOn,
				ForgotPasswordLabel: this.config.ForgotPasswordLabel,
				ForgotPasswordPage: this.forgotPasswordPage(),
				ForgotUsernameOn: this.config.ForgotUsernameOn,
				ForgotUsernameLabel: this.config.ForgotUsernameLabel,
				ForgotUsernamePage: this.forgotUsernamePage(),
				NewProfileOn: this.config.NewProfileOn && this.config.hideRegisterLink !== true,
				NewProfileTitle: this.config.NewProfileTitle,
				NewProfileLabel: this.config.NewProfileLabel,
				RegisterUserPage: this.registerUserPage(),
				instance: this.instance,
				oauthProviders : this.oauthProviders,
				showOAuthProviders: this.oauthProviders && this.oauthProviders.length > 0
			};
		}
	});
});
